export default "__VITE_ASSET__vXOdl8G9__"